import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../molecules/RoundedModal'
import SydButton from '../../../../../commonDesign/Button'
import SydModalActions from '../../../../../commonDesign/SydModal/SydModalActions'
import { useDeleteStatusTemplateMetadataTypeMutation } from '../../../../../../api/groups'

function DeleteMetadataTypeDialog ({ open, onClose, metadataType }) {
  const { mutateAsync: deleteMetadataType, isLoading } = useDeleteStatusTemplateMetadataTypeMutation()

  const handleDelete = useCallback(async () => {
    try {
      await deleteMetadataType({
        metadataTypeId: metadataType.metadataTypeId
      })
      onClose()
    } catch (error) {
      console.error('Failed to delete metadata type:', error)
    }
  }, [deleteMetadataType, metadataType, onClose])

  if (!metadataType) return null

  return (
    <RoundedModal
      title={`Delete ${metadataType.displayName} field`}
      subtitle='This action cannot be undone'
      open={open}
      onClose={onClose}
      position='top'
    >
      <div className='flex flex-col gap-5'>
        <div className='p-3 rounded' style={{ backgroundColor: 'var(--color-danger-200)', border: '1px solid var(--color-danger-600)' }}>
          <div className='font-size-xs'>Warning: This will permanently remove this metadata field configuration.</div>
        </div>

        <SydModalActions>
          <SydButton
            onClick={onClose}
            variant='outline'
            disabled={isLoading}
          >
            Cancel
          </SydButton>
          <SydButton
            onClick={handleDelete}
            variant='primary'
            priority='warning'
            processing={isLoading}
          >
            Delete Field
          </SydButton>
        </SydModalActions>
      </div>
    </RoundedModal>
  )
}

DeleteMetadataTypeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  metadataType: PropTypes.object
}

export default DeleteMetadataTypeDialog
